import api from "services/api";

// Fetch all employee leave balances with policy info
export const getEmployeeLeaveBalances = async () => {
  return api.get("/v1/api/admin/employee-leave-balances");
};

// Perform leave adjustment (credit, debit, reimburse)
export const adjustLeaveBalance = async (payload) => {
  return api.post("/v1/api/admin/leave-adjust", payload);
};

// Fetch audit log history of leave adjustments
export const getLeaveAdjustmentHistory = async (params) => {
  return api.get("/v1/api/admin/leave-adjustments", { params });
};
